import React from "react"
import { Menu } from "dash-styled"
import { APIAppWorker } from "../../../../../../../Models/API/AppWorker"
import { SortExpression } from "../../../../../../../Models/Client/SortExpression"
import { SortOptionField } from "../../../../../../Common/Button/SortChooser"
import { TableColumn } from "resha"
import { ReactComponent as IconGear } from "icons/lib/gear.svg"
import { getWorkerTypeDisplayText } from "../../../../../../../Models/API/WorkerType"
import { APIAppWorkerGroup } from "../../../../../../../Models/API/AppWorkerGroup"
import { NoData } from "../../../../../../Common/NoData/NoData"
import { toDisplayText } from "../../../../../../../Models/API/AppWorkerRole"

export const appWorkerSortOptions: SortOptionField<APIAppWorker>[] = [
    {
        field: "created",
        label: "Created",
        ascLabel: "Oldest first",
        descLabel: "Youngest first"
    },
    {
        field: "role",
        label: "Role",
        ascLabel: "Annotator first",
        descLabel: "Reviewer first"
    }
]

export const defaultAppWorkerSort: SortExpression<APIAppWorker> = {
    sortBy: "created",
    desc: true
}

export function appWorkerColumns<T extends string>(
    menuItems: T[],
    myEmail: string,
    onSelectMenu: (selected: T, id: number) => void
): TableColumn<APIAppWorker>[] {
    return [
        {
            renderHeader: () => "Name",
            render: ({ worker }) => (
                <>
                    {worker.type === "USER" ? worker.userUsername : worker.type}
                    {worker.type === "USER" && worker.userEmail === myEmail ? (
                        <span className="ml-1 italic">(you)</span>
                    ) : (
                        ""
                    )}
                </>
            )
        },
        {
            renderHeader: () => "Email",
            render: ({ worker }) =>
                worker.type === "USER" ? worker.userEmail : <NoData />
        },
        {
            renderHeader: () => "Type",
            render: appWorker => getWorkerTypeDisplayText(appWorker.worker.type)
        },
        {
            renderHeader: () => "Role",
            render: ({ role }) => toDisplayText(role)
        },
        {
            className: "w-24",
            renderHeader: () => "Modify",
            render: ({ worker }) => (
                <Menu
                    title={<IconGear className="w-4 h-4 -mt-px mr-3" />}
                    className="-my-1"
                    align="right"
                    nonInteractive={false}
                    items={menuItems}
                    onChoose={selected => onSelectMenu(selected, worker.id)}
                />
            )
        }
    ]
}

export const appWorkerGroupSortOptions: SortOptionField<APIAppWorkerGroup>[] = [
    {
        field: "created",
        label: "Created",
        ascLabel: "Oldest first",
        descLabel: "Youngest first"
    },
    {
        field: "role",
        label: "Role",
        ascLabel: "Annotator first",
        descLabel: "Reviewer first"
    }
]

export const defaultAppWorkerGroupSort: SortExpression<APIAppWorkerGroup> = {
    sortBy: "created",
    desc: true
}

export function appWorkerGroupColumns<T extends string>(
    menuItems: T[],
    onSelectMenu: (selected: T, id: number) => void
): TableColumn<APIAppWorkerGroup>[] {
    return [
        {
            renderHeader: () => "Name",
            render: appWorker => appWorker.workerGroupName
        },
        {
            renderHeader: () => "Role",
            render: ({ role }) => toDisplayText(role)
        },
        {
            className: "w-24",
            renderHeader: () => "Modify",
            render: ({ workerGroupId }) => (
                <Menu
                    title={<IconGear className="w-4 h-4 -mt-px mr-3" />}
                    className="-my-1"
                    align="right"
                    nonInteractive={false}
                    items={menuItems}
                    onChoose={selected => onSelectMenu(selected, workerGroupId)}
                />
            )
        }
    ]
}
